import { Login } from "./memberLogin";

document.addEventListener("DOMContentLoaded", () => {
  window.Login = new Login();
  window.Login.init();
});
